import React, {useState} from "react";
import {supabase} from "../../supabase";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store";
import {useTranslation} from "react-i18next";
import AuthLogo from "./AuthLogo";
import {Row} from "../../components/styled";
import {Alert, Box, Button, Card, CardContent, IconButton, InputAdornment, TextField, Typography} from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {useNavigate} from "react-router-dom";
import LanguageDialog from "../../components/LanguageDialog";

export default function () {

    const {t} = useTranslation();
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [langSwitch, setLangSwitch] = useState<boolean>(false);
    const [reveal, setReveal] = useState<boolean>(false);
    const navigate = useNavigate();
    const [error, setError] = useState("")

    async function login() {
        setLoading(true);
        const {data: {user}, error} = await supabase.auth.signInWithPassword({
            email: email,
            password: password,
        });
        if (!error && !user) {
            setLoading(false);
            alert("Check your email for the login link!");
            return
        }
        if (error) {
            setLoading(false);
            setError(error.message);
            return
        }

        setTimeout(() => {
            navigate("/menu/main")
        }, 300)
    }

    return <Card sx={{
        minWidth: 300,
        textAlign: "center",
        opacity: 0.95
    }}>
        <CardContent>
            <AuthLogo/>
            <Typography
                variant={"h4"}
                style={{
                    fontWeight: "bold",
                    alignSelf: "center",
                    padding: 30,
                }}
            >
                {t("auth.login")}
            </Typography>
            <Typography variant={"body2"}>{t("std.email")}</Typography>
            <TextField
                style={{marginTop: 0, width: "100%"}}
                variant={"outlined"}
                placeholder={t("auth.emailPlaceholder")}
                value={email}
                autoCapitalize="none"
                autoComplete={"username"}

                onChange={(e) => {
                    setEmail(e.target.value)
                    setError("")
                }}
            />

            <Typography variant={"body2"}>{t("auth.password")}</Typography>
            <TextField
                variant={"outlined"}
                style={{marginTop: 0, width: "100%"}}
                placeholder={t("auth.passwordPlaceholder")}
                value={password}
                autoCapitalize="none"
                autoComplete={"password"}
                type={reveal ? "text" : "password"}
                slotProps={{
                    input: {
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                aria-label={
                                    reveal ? 'hide the password' : 'display the password'
                                }
                                onClick={() => setReveal(!reveal)}
                                edge="end"
                            >
                                {reveal ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>
                        </InputAdornment>
                    }
                }}
                onChange={(e) => {
                    setPassword(e.target.value)
                    setError("")
                }}
            />
            <Box sx={{
                mt: 1
            }}>
                <Button
                    onClick={() => {
                        login();
                    }}
                    sx={{width: "100%"}}
                    variant={"contained"}
                    disabled={loading}
                >
                    {loading ? t("std.loading") : t("std.login")}
                </Button>


                <Button
                    onClick={() => {
                        navigate("/LoginOtp")
                    }}
                    variant={"text"}
                    sx={{
                        marginTop: 1,
                        width: "100%"
                    }}
                    disabled={loading}
                >
                    {t("auth.loginOtp")}
                </Button>
                {error && <Alert severity={"error"}>{error}</Alert>}
            </Box>

            <Row
                style={{
                    marginTop: "0.5em",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Button
                    onClick={() => {
                        navigate("/ForgetPassword");
                    }}
                >
                    {t("auth.forget")}
                </Button>
            </Row>

        </CardContent>
        {langSwitch && <LanguageDialog setSwitchLang={setLangSwitch}/>}
    </Card>;
}
